import { DeviceType } from "../common/data/service-proxies";

export const geometrisDeviceTypes = [
  {
    name: "Series 87",
    id: DeviceType.Series87,
  },
  {
    name: "Series 88",
    id: DeviceType.Series88,
  },
];

export const pacificTrackDeviceTypes = [
  {
    name: "PT30",
    id: DeviceType.PacificTrack30,
  },
  {
    name: "PT40",
    id: DeviceType.PacificTrack40,
  },
];

export const iosixDeviceTypes = [
  {
    name: "IO-1020",
    id: DeviceType.Io1020,
  },
];
